<template>
    <div id="header" class="fixed z-[1] top-0 w-full pc-max-width">
        <div
            class="pc-max-width w-full h-[48px] bg-white flex justify-between items-center px-20"
            :class="route.meta.notUseHeaderShadow ? '' : 'drop-shadow-header shadow-shadow'"
        >
            <div
                v-for="header in headers" :key="`header-${header}`"
                :class="header.type === 'LOGO' || header.type === 'TEXT' || header.type === 'PARAM' || header.type === 'CUSTOM-TEXT' ? 'flex-1 min-w-0 max-w-fit' : 'w-[116px]'"
            >
                <div
                    v-if="header.type === 'BACK'"
                    class="flex items-center cursor-pointer"
                    @click="goBack(header.to)"
                >
                    <icon-arrow />
                </div>

                <div
                    v-else-if="header.type === 'CUSTOM-BACK'"
                    class="flex items-center cursor-pointer"
                    @click="eventBus.emit('customEvent')"
                >
                    <icon-arrow />
                </div>

                <div
                    v-else-if="header.type === 'LOGO'"
                    class="cursor-pointer"
                    @click="router.push({ name: 'main' })"
                >
                    <icon-logo />
                </div>

                <div
                    v-else-if="header.type === 'TEXT'"
                >
                    <p class="bg-no-repeat bg-right truncate text-center" :class="header.class">
                        {{ $t(header.text) }}
                    </p>
                </div>

                <div
                    v-else-if="header.type === 'PARAM'"
                >
                    <p class="bg-no-repeat bg-right truncate text-center" :class="header.class">{{ route.params[header.param] }}</p>
                </div>

                <div
                    v-else-if="header.type === 'CUSTOM-TEXT'"
                >
                    <p class="bg-no-repeat bg-right truncate text-center" :class="header.class">{{ headerTitle }}</p>
                </div>

                <div
                    v-else-if="header.type === 'MENU'"
                    class="flex gap-10 items-center justify-end"
                >
                    <div class="cursor-pointer">
                        <icon-search @click="clickSearch" />
                    </div>

                    <div
                        class="cursor-pointer relative"
                        @click="clickCart"
                        v-if="false"
                    >
                        <icon-cart />
                        <div
                            v-if="cartCount > 0"
                            class="bg-warning h-[12px] min-w-[12px] text-white text-9 font-semibold flex justify-center items-center rounded-100 absolute top-0 left-[12px] px-3"
                        >{{ cartCount }}</div>
                    </div>
                </div>

                <div
                    v-else-if="header.type === 'CANCEL'"
                    class="flex items-center justify-end cursor-pointer"
                    @click="goBack(header.to)"
                >
                    <icon-cancel />
                </div>

                <div
                    v-else-if="header.type === 'TEXT-LINK'"
                    class="flex items-center justify-end cursor-pointer"
                    @click="eventBus.emit('customEvent')"
                >
                    <p :class="header.class">
                        {{ $t(header.text) }}
                    </p>
                </div>

                <div
                    v-else-if="header.type === 'STYLE'"
                    class="flex gap-10 items-center justify-end"
                >
                    <icon-shutter class="cursor-pointer" @click="goBack('/my_page/style/list')"/>
                    <icon-hamburger class="cursor-pointer" @click="goBack('/my_page/style')"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
// i18n
const { t } = useI18n();

// route
const router = useRouter();
const route = useRoute();

// data
const headers: any = ref([]);

const headerTitle: any = ref('');

const cartCount = ref(1);

// methods
const clickSearch = () => {
    alert(t('validation.ready'));
};
const clickCart = () => {
    alert(t('validation.ready'));
};
const setHeader = () => {
    if (route.meta.headers) {
        headers.value = route.meta.headers;
    } else {
        headers.value = [
            {
                type: 'LOGO'
            },
            {
                type: 'MENU'
            }
        ];
    }
};

const goBack = (to: any) => {
    if (to) {
        router.push(to);
    } else {
        router.back();
    }
};

const setHeaderTitle = (title: string) => {
    headerTitle.value = title;
};

onMounted(() => {
    setHeader();
    eventBus.on('setHeaderTitle', (title) => setHeaderTitle(title));
});

onUnmounted(() => {
    eventBus.off('setHeaderTitle', (title) => setHeaderTitle(title));
});

watch(route, () => {
    setHeader();
}, { deep: true });
</script>
